import { inputCognome, inputNome } from "_constants";
import { EmailInput, SelectUserRole, TextInput } from "components/shared";
import { Control, UseFormGetValues, UseFormTrigger } from "react-hook-form";

export const FormAddUser = ({
  control,
  getValues,
  trigger,
}: {
  control: Control<
    {
      name: string;
      lastName: string;
      email: string;
      role: number;
    },
    any
  >;
  getValues: UseFormGetValues<{
    name: string;
    lastName: string;
    email: string;
    role: number;
  }>;
  trigger: UseFormTrigger<{
    name: string;
    lastName: string;
    email: string;
    role: number;
  }>;
}) => {
  return (
    <>
      <div className="flex-column">
        <div className="flex-container gap-8">
          <div className="width-50">
            <TextInput control={control} name="name" placeholder={inputNome} />
          </div>
          <div className="width-50">
            <TextInput
              control={control}
              name="lastName"
              placeholder={inputCognome}
            />
          </div>
        </div>
        <div className="flex-container margin-top-8 gap-8">
          <div className="width-50">
            <EmailInput control={control} trigger={trigger} />
          </div>
          <div className="width-50">
            <SelectUserRole
              control={control}
              getValues={getValues}
              required={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};
